<template>
    <div>
        <!--        <nav class="navbar navbar-expand-lg navbar-light">-->
        <div class="ml-auto mb-2">
            <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchExportProducts">
                <!--                    <input-->
                <!--                        class="form-control mr-sm-2"-->
                <!--                        type="search"-->
                <!--                        placeholder="รหัสสินค้า"-->
                <!--                        aria-label="Search"-->
                <!--                        v-model="search.code"/>-->
                <multiselect
                    style="height: 100%"
                    v-model="search.code"
                    class="form-control border-0"
                    :options="optionProducts"
                    :customLabel="LabelSkuWithName"
                    placeholder="ค้นหาสินค้า"
                    :show-labels="false"
                    :close-on-select="false"
                    multiple
                    :searchable="true"
                    track-by="id">
                </multiselect>
                <date-picker
                    v-model="search.date"
                    type="datetime"
                    :format="changeFormat"
                    :range="true"
                    :lang="lang"
                    confirm
                    placeholder="วันที่อัพเดต">
                </date-picker>
                &nbsp
                <multiselect class="w-25" multiple placeholder="เลือกประเภทสินค้า" :customLabel="customLabelType"
                             track-by="value" :options="optionProductType" v-model="search.product_type"></multiselect>&nbsp;
                &nbsp
                <button
                    class="btn btn-success my-2 my-sm-0"
                    type="button"
                    @click="searchExportProducts">
                    <icon name="search"></icon>
                    ค้นหา
                </button>
                &nbsp
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportExcel">
                    <icon name="file-download"></icon>
                    พิมพ์ Excel
                </button>
                &nbsp
                <button type="button" class="btn btn-primary my-2 my-sm-0"
                        @click="printReportPDF">
                    <icon name="file-download"></icon>
                    พิมพ์ PDF
                </button>
            </form>
        </div>
        <!--        </nav>-->
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">ชื่อสินค้า</th>
                    <th scope="col">จำนวนสินค้าออก</th>
                    <th scope="col">วัน/เวลาที่นำออก</th>
                    <th scope="col">ผู้นำออก</th>
                    <th scope="col">หมายเหตุ</th>
                    <th scope="col" v-if="canViewSuperAdmin">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in exportProducts">
                    <td>
                        <template v-if="data.product">
                            {{ data.product.sku }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.product">
                            {{ data.product.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.quantity | amount }}</td>
                    <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else-if="data.user_id">
                            {{ data.user_id }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.reason }}</td>
                    <td v-if="canViewSuperAdmin">
                        <a @click="showExportProduct(data.id)">
                            <icon name="pencil-alt">
                            </icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash">
                            </icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="exportProducts.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getExportProductPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="loading">
            <loading :status="status" :msg="msg" @submit="hideLoadingModal"></loading>
        </b-modal>
        <br/>
        <!-- Modal Delete -->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteExportProduct">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideDeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!-- Modal edit Data -->
        <b-modal
            hide-footer
            ref="edit_data"
            id="import"
            title="นำเข้าวัตถุดิบ">
            <div v-if="edit_product.product">
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>รหัสสินค้า</label>
                    </b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="edit_product.product.sku" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="10" v-if="edit_product.product">
                    <b-col sm="4" class="col text-right">
                        <label>ชื่อสินค้า</label>
                    </b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="text"
                            v-model="edit_product.product.name" disabled/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>จำนวนสินค้านำออก</label>
                    </b-col>
                    <b-col sm="6">
                        <input
                            class="form-control"
                            type="number"
                            v-model="edit_product.quantity"/>
                    </b-col>
                </b-row>
                <br/>
                <b-row sm="11">
                    <b-col sm="4" class="col text-right">
                        <label>หมายเหตุ</label>
                    </b-col>
                    <b-col sm="6">
                        <textarea class="form-control" v-model="edit_product.reason"></textarea>
                    </b-col>
                </b-row>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button
                            type="button"
                            class="btn btn-success"
                            @click="saveExportProduct">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>
                        &nbsp;&nbsp;
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            @click="hideEditModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
            <!--<pre class="alert alert-primary">{{ edit_product }}</pre>-->
        </b-modal>
        <!--<pre class="alert alert-primary">{{ exportProducts }}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";
import {domain} from "../../../util/Constants";
import {canViewSuperAdmin} from "../../../util/Permissions";
import Loading from "../../Utility/Loading";
import Multiselect from "vue-multiselect";

export default {
    components: {Loading, VuePagination, DatePicker, Multiselect},
    name: "export-products",
    created() {
        this.$store.dispatch("ExportProduct/get").then(res => {
            this.exportProducts = res.data;
            this.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            }
        });
        this.domain = domain;
    },
    data() {
        return {
            msg: '',
            status: '',
            search: {
                code: "",
                date: "",
                product_type: "",
            },
            shift: "",
            event_submit: false,
            activeCloseDate: false,
            dateFormat: 'D/MM/YYYY',
            dateOne: '',
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            exportProducts: [],
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
        };
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            },
            edit_product: state => {
                return state.ExportProduct.replace_data;
            },
            optionProductType: state => {
                return [
                    ...state.ProductType.data.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            },
            optionProducts: state => {
                return state.ProductType.product;
            },
        })
    },
    methods: {
        LabelSkuWithName(option) {
            if (this.optionProducts.length > 0) {
                return `${option.sku} - ${option.name}`
            }
        },
        customLabelType(option) {
            return `${option.text}`
        },
        //Modal
        showDeleteModal(id) {
            this.id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        showEditModal(id) {
            this.id = id;
            this.$refs.edit_data.show();
        },
        hideEditModal() {
            this.$refs.edit_data.hide();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },

        //API
        showExportProduct(id) {
            this.showEditModal(id);
            this.$store.dispatch("ExportProduct/show", id);
        },
        deleteExportProduct() {
            this.$store.dispatch("ExportProduct/delete", this.id).then(() => {
                this.hideDeleteModal();
                this.$store.dispatch("ExportProduct/get");
                this.$store.dispatch("Products/setProducts");
            });
        },
        saveExportProduct() {
            if (this.edit_product.quantity < 0 || this.edit_product.quantity > this.edit_product.product.quantity) {
                alert("กรุณาใส่จำนวนให้ถูกต้อง")
            } else {
                this.$store
                    .dispatch("ExportProduct/update", {
                        id: this.id,
                        data: this.edit_product
                    })
                    .then(data => {
                        if (!data) {
                            alert("กรุณาใส่หมายเหตุไม่เกิน 255 ตัวอักษร")
                        } else {
                            this.$store.dispatch("ExportProduct/get").then(() => {
                                this.hideEditModal();
                            });
                            this.$store.dispatch("Products/setProducts");
                        }
                    })
            }
        },
        searchExportProducts() {
            this.event_submit = true;
            let date_start = '';
            let date_end = '';
            if (this.search.date) {
                date_start = moment(this.search.date[0]).format("YYYY-MM-DD HH:mm:ss");
                date_end = moment(this.search.date[1]).format("YYYY-MM-DD HH:mm:ss");
            }
            let type_id = '';
            if (this.search.product_type) {
                this.search.product_type.forEach((x, i) => {
                    if (i > 0) type_id += ',' + x.value
                    else type_id += x.value
                })
            }
            let product_id = '';
            if (this.search.code.length > 0) {
                this.search.code.forEach((v, i) => {
                    i > 0 ? product_id += ',' + v.id : product_id += v.id;
                })
            }
            this.showLoadingModal();
            this.status = 1;
            this.msg = "กำลังดาวโหลดข้อมล";
            this.$store.dispatch("ExportProduct/search", {
                code: product_id,
                date_start: date_start,
                date_end: date_end,
                type_id: type_id,
            }).then(res => {
                this.exportProducts = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.form,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
                this.hideLoadingModal();
            });
        },
        printReportExcel() {
            if (!this.search.date) {
                alert("กรุณาเลือกวันที่นำออก ที่ต้องการพิมพ์")
            } else {
                let date_start = moment(this.search.date[0]).format("YYYY-MM-DD HH:mm:ss");
                let date_end = moment(this.search.date[1]).format("YYYY-MM-DD HH:mm:ss");
                // let code = this.search.code;
                let product_id = '';
                if (this.search.code.length > 0) {
                    this.search.code.forEach((v, i) => {
                        i > 0 ? product_id += ',' + v.id : product_id += v.id;
                    })
                }
                let type_id = '';
                if (this.search.product_type) {
                    this.search.product_type.forEach((x, i) => {
                        if (i > 0) type_id += ',' + x.value
                        else type_id += x.value
                    })
                }
                window.open(this.domain + '/print-export-product' + "?date_start=" + date_start + "&date_end=" + date_end + "&code=" + product_id + "&type_id=" + type_id + "&file=excel");
            }
        },
        printReportPDF() {
            if (!this.search.date) {
                alert("กรุณาเลือกวันที่นำออก ที่ต้องการพิมพ์")
            } else {
                let date_start = moment(this.search.date[0]).format("YYYY-MM-DD HH:mm:ss");
                let date_end = moment(this.search.date[1]).format("YYYY-MM-DD HH:mm:ss");
                // let code = this.search.code;
                let product_id = '';
                if (this.search.code.length > 0) {
                    this.search.code.forEach((v, i) => {
                        i > 0 ? product_id += ',' + v.id : product_id += v.id;
                    })
                }
                let type_id = '';
                if (this.search.product_type) {
                    this.search.product_type.forEach((x, i) => {
                        if (i > 0) type_id += ',' + x.value
                        else type_id += x.value
                    })
                }
                window.open(this.domain + '/print-export-product' + "?date_start=" + date_start + "&date_end=" + date_end + "&code=" + product_id + "&type_id=" + type_id + "&file=pdf");
            }
        },
        getExportProductPage() {
            const page = this.dataPaginate.current_page;
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = ""
            }
            let product_id = '';
            if (this.search.code.length > 0) {
                this.search.code.forEach((v, i) => {
                    i > 0 ? product_id += ',' + v.id : product_id += v.id;
                })
            }
            this.showLoadingModal();
            this.status = 1;
            this.msg = "กำลังดาวโหลดข้อมล";
            if (this.event_submit) {
                this.$store.dispatch("ExportProduct/search", {
                    page: page,
                    code: product_id,
                    date: this.search.date
                }).then(res => {
                    this.exportProducts = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                    this.hideLoadingModal();
                });
            } else {
                this.$store.dispatch('ExportProduct/get', page).then(res => {
                    this.exportProducts = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.form,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    }
                    this.hideLoadingModal();
                });
            }

        },
    }
};
</script>

<style lang="scss" scoped>
</style>
